/**
 * Extract just the flight number code, removing any time that might be appended
 * e.g., "PC331 14:15" -> "PC331"
 * e.g., "LO 537 17:10" -> "LO537"
 * @param {string} flightString - The raw flight string that may contain time
 * @returns {string|null} - The extracted flight number or null if no input
 */
function extractFlightNumber(flightString) {
  if (!flightString) return null;

  // Trim whitespace first
  const trimmed = flightString.trim();
  if (!trimmed) return null;

  // Combined regex that matches all flight number patterns:
  // - 2-3 letters followed by optional space and 1-4 digits (FR9895, BA123, LO 537, LOT123)
  // - 1 letter + 1 digit followed by optional space and 1-4 digits (W62345, W6 2345 for Wizz Air)
  // - 1 digit + 1 letter followed by optional space and 1-4 digits (3U8123, 3U 8123 for Sichuan)
  const match = trimmed.match(/^([A-Z]{2,3})\s?(\d{1,4})|^([A-Z]\d)\s?(\d{1,4})|^(\d[A-Z])\s?(\d{1,4})/i);
  if (match) {
    // Find which capture groups matched and combine them (removing any space)
    if (match[1] && match[2]) {
      return (match[1] + match[2]).toUpperCase();
    }
    if (match[3] && match[4]) {
      return (match[3] + match[4]).toUpperCase();
    }
    if (match[5] && match[6]) {
      return (match[5] + match[6]).toUpperCase();
    }
  }

  // If no pattern matches but string looks like it could be a flight number
  // (starts with alphanumeric, doesn't contain time markers like :)
  // return the first word
  const firstWord = trimmed.split(/[\s,]+/)[0];
  if (firstWord && !firstWord.includes(':')) {
    return firstWord.toUpperCase();
  }

  return trimmed;
}

export default extractFlightNumber;
